import { connect } from 'react-redux';

import { closeDialog } from '../../actions/Dialog';

import DialogSupportComplete from '../../components/Dialogs/DialogSupportComplete/DialogSupportComplete';

const mapStateToProps = (state) => ({
    //versions: state.details.data.versions,
})

const mapDispatchToProps = (dispatch) => ({
    onCloseDialog: () => {
        dispatch(closeDialog())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DialogSupportComplete)
